import { App, Component } from 'vue';
import BaseIcon from '@/components/atoms/BaseIcon/BaseIcon.vue';
import VChannelLabel from '@/components/atoms/VChannelLabel/VChannelLabel.vue';
import IconBell from '@/components/atoms/icons/IconBell.vue';
import IconBellOff from '@/components/atoms/icons/IconBellOff.vue';
import IconBellOn from '@/components/atoms/icons/IconBellOn.vue';
import IconCalendar from '@/components/atoms/icons/IconCalendar.vue';
import IconCheck from '@/components/atoms/icons/IconCheck.vue';
import IconChevronLeft from '@/components/atoms/icons/IconChevronLeft.vue';
import IconChevronRight from '@/components/atoms/icons/IconChevronRight.vue';
import IconChevronRightCircleOutline from '@/components/atoms/icons/IconChevronRightCircleOutline.vue';
import IconClose from '@/components/atoms/icons/IconClose.vue';
import IconDotsCircleOutline from '@/components/atoms/icons/IconDotsCircleOutline.vue';
import IconFilter from '@/components/atoms/icons/IconFilter.vue';
import IconGenre from '@/components/atoms/icons/IconGenre.vue';
import IconHome from '@/components/atoms/icons/IconHome.vue';
import IconList from '@/components/atoms/icons/IconList.vue';
import IconMylist from '@/components/atoms/icons/IconMyList.vue';
import IconMyListOff from '@/components/atoms/icons/IconMyListOff.vue';
import IconMyListOn from '@/components/atoms/icons/IconMyListOn.vue';
import IconPhone from '@/components/atoms/icons/IconPhone.vue';
import IconPresent from '@/components/atoms/icons/IconPresent.vue';
import IconSearch from '@/components/atoms/icons/IconSearch.vue';
import IconSort from '@/components/atoms/icons/IconSort.vue';
import IconTrash from '@/components/atoms/icons/IconTrash.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import NoneFooterLayout from '@/layouts/NoneFooterLayout.vue';

const components: { [name: string]: Component } = {
  BaseIcon,
  IconBell,
  IconBellOff,
  IconBellOn,
  IconCalendar,
  IconCheck,
  IconChevronLeft,
  IconChevronRight,
  IconChevronRightCircleOutline,
  IconClose,
  IconDotsCircleOutline,
  IconFilter,
  IconGenre,
  IconHome,
  IconList,
  IconMylist,
  IconMyListOn,
  IconMyListOff,
  IconPhone,
  IconPresent,
  IconSearch,
  IconSort,
  IconTrash,
  DefaultLayout,
  NoneFooterLayout,
  VChannelLabel,
};

export const registerComponent = (app: App): void => {
  for (const name of Object.keys(components)) {
    app.component(name, components[name]);
  }
};
